import React from 'react'
import {
    ShowController,
    Show,
    SimpleShowLayout,
    TextField,
    BooleanField,
    FunctionField,
    ReferenceField,
    Component
} from 'react-admin'
import CopyButton from '../../components/CopyButton'
import { Card, CardContent, Tooltip, Typography } from '@material-ui/core';
import { BackToOrgButton } from '../../components/Organization/OrgButtons.js'
import { parse } from "query-string";
import CustomShowActions from '../../components/CustomShowActions'
import useUser from '../../hooks/useUser';
import zoneAlerts from '../../defaults/ZoneAlerts'
import RenameTextField from '../../components/RenameTextField'
import TriggerZoneButton from '../../components/Zone/TriggerZoneButton';
import LoadImage from '../../components/LoadImage';
import PanelEventsList from '../../components/Panel/PanelEventsList';
import ZoneAdminCard from '../../components/Zone/ZoneAdminCard';
import ZoneInfoCard from '../../components/Zone/ZoneInfoCard';


const ZoneShow = (props) => {
    const user = useUser()

    const { organization_id } = parse(props.location.search);
    const isSuperAdmin = user.role === "super-admin";

    return (
        <ShowController {...props} >
            {controllerProps =>
                <Show {...props}
                    component={"div"} actions={<CustomShowActions overrideOrgID={organization_id} />} title="Zone">

                    <SimpleShowLayout >
                        <Card style={{ marginBottom: '20px', padding: "1rem" }}>
                            <CardContent>
                                {isSuperAdmin && (
                                    <tr>
                                        <td style={{ gridColumn: "span 2" }}>
                                            <CopyButton label="Alarm.com ID">
                                                <FunctionField render={(record) => <h1>#ASR#{record.id}</h1>} />
                                            </CopyButton>
                                        </td>
                                    </tr>
                                )}
                                <ZoneInfoCard {...controllerProps} />

                                {isSuperAdmin && <div>
                                    <TriggerZoneButton zoneId={props.id} />
                                </div>}
                                <FunctionField label="Zone State" render={record => {
                                    return record.state ? <ZoneAdminCard state={record.state} /> : 'Good';
                                }} />
                            </CardContent>
                        </Card>
                        <LoadImage record={props.record} />
                        {user.role === "super-admin" && <div>
                            <Typography variant="h4" gutterBottom>Panel Events</Typography>
                            <Card>
                                <CardContent>
                                    <PanelEventsList ignoreZone={true} ignoreOrg={true} filter={{ zone_id: props && props.record ? props.record.id : props.id }} />
                                </CardContent>
                            </Card>
                        </div>}
                    </SimpleShowLayout>
                </Show>
            }
        </ShowController>
    )
}

export default ZoneShow